module.exports = __webpack_public_path__ + "static/media/xlsx.120bcf25.svg";